import { createContext, useContext, type ReactNode } from 'react';

/**
 * The route prefix the marketplace pages live under, so a single set of pages
 * (browse / product / cart / checkout / orders) can be mounted at both
 * `/industry/marketplace` (customer) and `/company/stores` (company workspace).
 */
const Ctx = createContext<string>('/industry/marketplace');

export function MarketplaceBaseProvider({ base, children }: { base: string; children: ReactNode }) {
  return <Ctx.Provider value={base}>{children}</Ctx.Provider>;
}

export function useMarketplaceBase(): string {
  return useContext(Ctx);
}
